import { useNavigate, useParams } from '@tanstack/react-router';
import { CashReceiptDetailSlidein } from '@/components/accounts-receivable/cash-receipt-detail/cash-receipt-detail-slidein';

export function CashReceiptDetailRoute() {
  const { receiptId } = useParams({
    from: '/authenticated/accounts-receivable/cash-receipts/$receiptId',
  });
  const navigate = useNavigate();

  return (
    <CashReceiptDetailSlidein
      receiptId={receiptId}
      isOpen
      onOpenChange={() => {
        navigate({ to: '..', search: true, viewTransition: true });
      }}
    />
  );
}
